<div class="tabs">
  <div class="tabs__head">
    @for (tab of tabs(); track tab.tabId()) {
      <button
        class="tabs__tab-label"
        [attr.data-testid]="tab.testId()"
        [class.tabs__tab-label--active]="tab.tabId() === activeTabId()"
        (click)="onTabClick(tab.tabId())"
      >
        <span>
          {{ tab.label() }}
        </span>
      </button>
    }
  </div>
  <div class="tabs__content">
    @for (tab of tabs(); track tab.tabId()) {
      @if (tab.tabId() === activeTabId()) {
        <ng-container *ngTemplateOutlet="tab.template()"></ng-container>
      }
    }
  </div>
</div>
